import type { PostPurchaseRecommendationsResponse } from "@/domains/surveys/models/types";

export const createPostPurchaseRecommendationsDataModel = (
  recommendations: PostPurchaseRecommendationsResponse,
) => {
  return {
    buyer: recommendations.buyer,
    nextSteps: recommendations.steps,
    upsellProducts: recommendations.products.map((product) => {
      return {
        ...product,
        displayPrice: `$${product.price / 100}`,
      };
    }),
  };
};
